const TRACKED_SOURCE_KEY = "trackedSource";
const META_SOURCE_KEY = "utm_meta_source";
// First-party cookie written by the RedTrack Uniclick script (public/index.html).
const REDTRACK_CLICK_ID_COOKIE = "rtkclickid-store";

// Called once at startup: ad links land on any page, and in-app navigation drops the query string.
export const captureTrackingParams = () => {
  const params = new URLSearchParams(window.location.search);
  const source = params.get("source");
  const metaSource = params.get("utm_meta_source");
  if (source) localStorage.setItem(TRACKED_SOURCE_KEY, source);
  if (metaSource) localStorage.setItem(META_SOURCE_KEY, metaSource);
};

export const getTrackedSource = () =>
  localStorage.getItem(TRACKED_SOURCE_KEY) || window.location.hostname;

export const getMetaPixelId = () => localStorage.getItem(META_SOURCE_KEY) || undefined;

// RedTrack click ID for server-side conversion attribution, read from the
// first-party cookie the Uniclick script sets after generating the ID.
export const getRedTrackClickId = () => {
  try {
    const prefix = `${REDTRACK_CLICK_ID_COOKIE}=`;
    const cookie = document.cookie.split("; ").find((item) => item.startsWith(prefix));
    return cookie ? decodeURIComponent(cookie.slice(prefix.length)) || undefined : undefined;
  } catch {
    return undefined;
  }
};
